import { render, staticRenderFns } from "./ProfileEditDialog.vue?vue&type=template&id=648c9a45&scoped=true"
import script from "./ProfileEditDialog.vue?vue&type=script&lang=js"
export * from "./ProfileEditDialog.vue?vue&type=script&lang=js"
import style0 from "./ProfileEditDialog.vue?vue&type=style&index=0&id=648c9a45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648c9a45",
  null
  
)

export default component.exports